import { Cascader } from 'antd'
import api from 'api'
import React, { useEffect, useState } from 'react'

interface SelectPageComponentProps {
	application: string
	style?: React.CSSProperties
	isPage?: boolean
	onChange?: (selectedOptions: any) => void
}
export const SelectPageComponent = (props: SelectPageComponentProps) => {
	const [options, setOptions] = useState([])
	const loadOptions = async (application: string, typeEnum: number) => {
		setOptions(await api.modeling.apppage.GetModuleOrComponent({ application, typeEnum }))
	}
	useEffect(() => {
		loadOptions(props.application, 0)
	}, [])

	const onChange = (value: any, selectedOptions: any) => {
		console.log('selectedOptions', selectedOptions, value)
		props.onChange && props.onChange(selectedOptions.find((s: any) => s.typeEnum === (props.isPage ? 2 : 3)) || {})
	}

	const loadData = async (selectedOptions: any) => {
		const targetOption = selectedOptions[selectedOptions.length - 1]
		targetOption.loading = true
		// load options lazily
		let children = await api.modeling.apppage.GetModuleOrComponent({
			application: targetOption.application,
			typeEnum: targetOption.typeEnum === 0 ? 1 : props.isPage ? 2 : 3,
		})
		targetOption.loading = false
		targetOption.children = children
		setOptions([...options])
	}
	return (
		<Cascader
			style={props.style}
			fieldNames={{ label: 'name', value: 'id' }}
			options={options}
			loadData={loadData}
			onChange={onChange}
			changeOnSelect
		/>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageLayoutDesiger/SelectPageComponent.tsx